(function () {
	const initialUrlParams = new URL(window.location.href).searchParams;
	let trioBundleEditKey = initialUrlParams.get('edit');
	let trioCinchBundleEditId = parseCinchBundleId(initialUrlParams.get('bundle'));
	let trioBundleEditItem = null;
	let trioBundleDefaultButtonText = null;
	let trioCinchEditOriginal = null;
	let trioCinchEditReady = false;
	const CINCH_LINE_PROPERTIES = {
		campaignId: '_cinch_campaign_id',
		bundleId: '_cinch_bundle_id',
		tierId: '_cinch_tier_id',
		role: '_cinch_role',
		checksum: '_cinch_config_checksum',
		sourcePath: '_cinch_source_path',
		sourceQuery: '_cinch_source_query',
		sourceCarrier: '_cinch_source_v1'
	};
	const CINCH_SOURCE_CARRIER_MAX_BYTES = 128;
	const CINCH_MAX_MERGE_BUNDLES = 20;
	const CINCH_BUNDLE_LIMIT_MESSAGE = 'Your cart already has 20 bundles. Remove one before adding another.';
	const CINCH_PREVIEW_URL_PARAM = 'cinch_preview';
	const CINCH_PREVIEW_STORAGE_KEY = 'cinch:preview';

	function parseCinchBundleId(value) {
		return typeof value === 'string' && /^cinch_[a-zA-Z0-9]{1,10}_[a-z0-9]+_[a-z0-9]{4}$/.test(value)
			? value
			: null;
	}

	function getTrioCartProperty(properties, propertyName) {
		if (!properties) return '';
		if (Array.isArray(properties)) {
			const property = properties.find(function (property) {
				return property && property[0] === propertyName;
			});
			return property ? property[1] : '';
		}
		return properties[propertyName] || '';
	}

	function getTrioEditComponents(bundleItem) {
		if (!bundleItem || !Array.isArray(bundleItem.item_components)) return [];
		return bundleItem.item_components.filter(function (itemComponent) {
			const legacyTrio = getTrioCartProperty(itemComponent.properties, '_bundle_type') === 'trio';
			const cinchPaidLine = getTrioCartProperty(itemComponent.properties, CINCH_LINE_PROPERTIES.role) === 'paid';
			return parseInt(itemComponent.id, 10) !== parseInt(bundleItem.id, 10)
				&& (legacyTrio || cinchPaidLine);
		});
	}

	function normalizeCinchCartComponent(item) {
		const variantId = positiveInteger(item && (item.variant_id || item.id));
		const quantity = Number(item && item.quantity);
		if (variantId === null || !Number.isFinite(quantity) || quantity <= 0) return null;
		return {
			id: variantId,
			variantId: String(variantId),
			productId: String((item && item.product_id) || ''),
			quantity: Math.floor(quantity),
			role: getTrioCartProperty(item && item.properties, CINCH_LINE_PROPERTIES.role),
			campaignId: getTrioCartProperty(item && item.properties, CINCH_LINE_PROPERTIES.campaignId),
			properties: item && item.properties
		};
	}

	function getCinchEditComponents(bundleItem, cartItems, bundleId) {
		let rawComponents = bundleItem && Array.isArray(bundleItem.item_components)
			? bundleItem.item_components
			: [];

		if (!rawComponents.length && Array.isArray(cartItems)) {
			rawComponents = cartItems.filter(function (item) {
				return getTrioCartProperty(item.properties, CINCH_LINE_PROPERTIES.bundleId) === bundleId
					&& ['paid', 'gift'].includes(getTrioCartProperty(item.properties, CINCH_LINE_PROPERTIES.role));
			});
		}

		return rawComponents
			.map(normalizeCinchCartComponent)
			.filter(function (component) { return component !== null; });
	}

	function captureCinchOriginal(components, config) {
		const anyRole = components.some(function (component) {
			return component.role === 'paid' || component.role === 'gift';
		});
		const giftIds = new Set();
		config.t.forEach(function (tier) {
			if (Array.isArray(tier.gv)) tier.gv.forEach(function (variantId) { giftIds.add(variantId); });
		});
		const paidByVariant = {};
		const gifts = [];

		components.forEach(function (component) {
			const role = anyRole
				? component.role
				: (giftIds.has(component.variantId) && component.quantity === 1 ? 'gift' : 'paid');
			if (role === 'paid') {
				if (!paidByVariant[component.variantId]) {
					paidByVariant[component.variantId] = {
						id: component.id,
						variantId: component.variantId,
						productId: component.productId,
						quantity: 0
					};
				}
				paidByVariant[component.variantId].quantity += component.quantity;
			} else if (role === 'gift' && !gifts.some(function (gift) { return gift.variantId === component.variantId; })) {
				gifts.push({
					id: component.id,
					variantId: component.variantId,
					productId: component.productId,
					quantity: 1
				});
			}
		});

		return { paid: Object.values(paidByVariant), gifts: gifts };
	}

	function getTrioSection(element) {
		return element ? element.closest('[id^="MainProduct-"]') : null;
	}

	function getCinchCampaignId(section) {
		return section ? (section.dataset.trioCinchCampaignId || '').trim() : '';
	}

	function getCinchConfig(section) {
		const campaignId = getCinchCampaignId(section);
		const script = section && section.querySelector('script[data-trio-cinch-config]');
		if (!campaignId || !script) return null;
		if (section.dataset.trioCinchPreview && section.dataset.trioCinchPreviewAuthorized !== 'true') return null;

		try {
			const config = JSON.parse(script.textContent || 'null');
			if (!config || config.v !== 1 || config.i !== campaignId) return null;
			if (!/^[0-9a-f]{16}$/.test(config.cs) || !Array.isArray(config.t) || !config.t.length) return null;
			if (!Array.isArray(config.ev) || !Array.isArray(config.ep) || !Array.isArray(config.xv)) return null;
			return config;
		} catch (error) {
			return null;
		}
	}

	function readCinchPreviewToken() {
		let token = null;
		try {
			token = new URLSearchParams(window.location.search).get(CINCH_PREVIEW_URL_PARAM);
		} catch (error) {
			token = null;
		}

		if (token) {
			try {
				window.sessionStorage.setItem(CINCH_PREVIEW_STORAGE_KEY, token);
			} catch (error) {
				// Storage can be blocked; the URL token still works for this page.
			}
			return token;
		}

		try {
			return window.sessionStorage.getItem(CINCH_PREVIEW_STORAGE_KEY);
		} catch (error) {
			return null;
		}
	}

	async function cinchPreviewGateMatches(gate) {
		const token = readCinchPreviewToken();
		if (!token || !/^[0-9a-f]{16}$/.test(gate)) return false;
		try {
			const bytes = new TextEncoder().encode(token);
			const digest = await window.crypto.subtle.digest('SHA-256', bytes);
			const actualGate = Array.from(new Uint8Array(digest).slice(0, 8))
				.map(function (byte) { return byte.toString(16).padStart(2, '0'); })
				.join('');
			return actualGate === gate;
		} catch (error) {
			return false;
		}
	}

	function prependCinchPreviewNotice(section) {
		if (section.querySelector('[data-trio-cinch-preview-notice]')) return;
		const notice = document.createElement('div');
		notice.setAttribute('data-trio-cinch-preview-notice', '');
		notice.setAttribute('role', 'status');
		notice.style.cssText = 'margin:0 0 12px;padding:10px 14px;border-radius:8px;'
			+ 'background:#fff4e5;color:#663c00;font-size:13px;line-height:1.45;';
		const label = document.createElement('strong');
		label.textContent = 'Preview — only people with the preview link see this. ';
		notice.appendChild(label);
		notice.append('Bundle prices apply when this campaign goes live.');
		section.prepend(notice);
	}

	async function initializeCinchPreview(section) {
		if (!section || section.dataset.trioCinchPreviewState) return;
		const gate = section.dataset.trioCinchPreview;
		if (!gate) return;
		section.dataset.trioCinchPreviewState = 'pending';

		if (!(await cinchPreviewGateMatches(gate))) {
			section.dataset.trioCinchPreviewState = 'denied';
			section.remove();
			return;
		}

		section.dataset.trioCinchPreviewAuthorized = 'true';
		if (!getCinchConfig(section)) {
			section.dataset.trioCinchPreviewState = 'invalid';
			return;
		}

		section.dataset.trioCinchPreviewState = 'ready';
		prependCinchPreviewNotice(section);
		section.removeAttribute('hidden');
		updateTrioButtonAvailability(section);
	}

	function initializeCinchPreviews(scope) {
		const sections = [];
		if (scope && typeof scope.matches === 'function' && scope.matches('[data-trio-cinch-preview]')) {
			sections.push(scope);
		}
		if (scope && typeof scope.querySelectorAll === 'function') {
			scope.querySelectorAll('[data-trio-cinch-preview]').forEach(function (section) {
				if (sections.indexOf(section) === -1) sections.push(section);
			});
		}
		return Promise.all(sections.map(function (section) { return initializeCinchPreview(section); }));
	}

	function positiveInteger(value) {
		const stringValue = String(value || '');
		if (!/^\d+$/.test(stringValue)) return null;
		const numberValue = Number(stringValue);
		return Number.isSafeInteger(numberValue) && numberValue > 0 ? numberValue : null;
	}

	function getSelectedTrioItems(section) {
		if (!section) return [];
		return Array.from(section.querySelectorAll('.trio-bundle-container [data-trio-product]:not(.hidden)'))
			.map(function (card) {
				const checkedVariant = card.querySelector('.trio-options-container input[data-variant-id]:checked');
				const variantId = String(checkedVariant ? checkedVariant.dataset.variantId : card.dataset.variantId || '');
				return {
					id: positiveInteger(variantId),
					variantId: variantId,
					productId: String(card.dataset.productId || '')
				};
			});
	}

	function selectCinchTier(tiers, paidCount) {
		let selected = null;
		tiers.forEach(function (tier) {
			const inRange = Number.isInteger(tier.mn)
				&& paidCount >= tier.mn
				&& (tier.mx === null || (Number.isInteger(tier.mx) && paidCount <= tier.mx));
			if (inRange && (!selected || tier.mn > selected.mn)) selected = tier;
		});
		return selected;
	}

	function cinchItemIsEligible(config, item) {
		if (config.xv.includes(item.variantId)) return false;
		return config.ev.includes(item.variantId) || (item.productId && config.ep.includes(item.productId));
	}

	function findCinchSection(config, item) {
		if (!Array.isArray(config.sec) || !config.sec.length) return null;
		return config.sec.find(function (bundleSection) {
			return bundleSection.ev.includes(item.variantId)
				|| (item.productId && bundleSection.ep.includes(item.productId));
		}) || null;
	}

	function validateCinchSections(config, items) {
		if (!Array.isArray(config.sec) || !config.sec.length) return true;
		const counts = {};

		for (const item of items) {
			const bundleSection = findCinchSection(config, item);
			if (!bundleSection) return false;
			counts[bundleSection.i] = (counts[bundleSection.i] || 0) + 1;
		}

		return config.sec.every(function (bundleSection) {
			const count = counts[bundleSection.i] || 0;
			return count >= bundleSection.mn && (bundleSection.mx === null || count <= bundleSection.mx);
		});
	}

	function validateCinchQuantityCap(config, items) {
		if (!Number.isInteger(config.mq) || config.mq <= 0) return true;
		const counts = {};
		for (const item of items) {
			const key = config.mqv ? item.variantId : (item.productId || item.variantId);
			counts[key] = (counts[key] || 0) + 1;
			if (counts[key] > config.mq) return false;
		}
		return true;
	}

	function cinchMinimumGiftCount(tier) {
		if (tier.gm === 'n') return 0;
		return tier.few || tier.gm === 'o' ? tier.g0 : tier.g1;
	}

	function getCinchSource() {
		const params = new URLSearchParams(window.location.search);
		params.delete('edit');
		params.delete('bundle');
		params.delete(CINCH_PREVIEW_URL_PARAM);
		if (params.getAll('view').some(function (value) { return value.indexOf('cinch-') === 0; })) {
			params.delete('view');
		}

		return { path: window.location.pathname, query: params.toString() };
	}

	function getCinchSourceCarrier(source) {
		const value = source.path + (source.query ? '?' + source.query : '');
		if (value.charAt(0) !== '/' || value.charAt(1) === '/') return null;
		const encoder = new TextEncoder();
		if (encoder.encode(value).length <= CINCH_SOURCE_CARRIER_MAX_BYTES) return value;
		return encoder.encode(source.path).length <= CINCH_SOURCE_CARRIER_MAX_BYTES
			? source.path
			: null;
	}

	function createCinchBundleId(campaignId) {
		const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
		const campaignPrefix = campaignId.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10) || 'c';
		let suffix = '';
		if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
			const bytes = new Uint8Array(4);
			window.crypto.getRandomValues(bytes);
			bytes.forEach(function (byte) { suffix += alphabet[byte % alphabet.length]; });
		} else {
			for (let index = 0; index < 4; index += 1) {
				suffix += alphabet[Math.floor(Math.random() * alphabet.length)];
			}
		}
		return 'cinch_' + campaignPrefix + '_' + Date.now().toString(36) + '_' + suffix;
	}

	function buildCinchLineProperties(config, tier, bundleId, role, source, carrySource) {
		const properties = {
			[CINCH_LINE_PROPERTIES.campaignId]: config.i,
			[CINCH_LINE_PROPERTIES.bundleId]: bundleId,
			[CINCH_LINE_PROPERTIES.tierId]: tier.i,
			[CINCH_LINE_PROPERTIES.role]: role,
			[CINCH_LINE_PROPERTIES.checksum]: config.cs
		};
		if (source.path) properties[CINCH_LINE_PROPERTIES.sourcePath] = source.path;
		if (source.query) properties[CINCH_LINE_PROPERTIES.sourceQuery] = source.query;
		const sourceCarrier = carrySource ? getCinchSourceCarrier(source) : null;
		if (sourceCarrier) properties[CINCH_LINE_PROPERTIES.sourceCarrier] = sourceCarrier;
		return properties;
	}

	// Cinch's Cart Transform creates the merged parent. This theme sends only
	// the paid and gift component lines; adding the merchandise parent here
	// would poison the bundle group and prevent the configured price applying.
	function buildCinchCartItems(config, tier, bundleId, paidItems, giftItems) {
		const source = getCinchSource();
		const items = paidItems.map(function (item, index) {
			return {
				id: item.id,
				quantity: item.quantity,
				properties: buildCinchLineProperties(config, tier, bundleId, 'paid', source, index === 0)
			};
		});
		giftItems.forEach(function (item) {
			items.push({
				id: item.id,
				quantity: 1,
				properties: buildCinchLineProperties(config, tier, bundleId, 'gift', source)
			});
		});
		return items;
	}

	function expandCinchPaidItems(paidItems) {
		const expanded = [];
		paidItems.forEach(function (item) {
			for (let quantity = 0; quantity < item.quantity; quantity += 1) expanded.push(item);
		});
		return expanded;
	}

	function validateCinchGifts(tier, giftItems) {
		const minimum = cinchMinimumGiftCount(tier);
		const maximum = tier.gm === 'n' ? 0 : tier.g1;
		if (!Number.isInteger(maximum) || giftItems.length < minimum || giftItems.length > maximum) return false;
		if (giftItems.some(function (item) { return item.id === null; })) return false;
		return giftItems.every(function (item) {
			return Array.isArray(tier.gv) && tier.gv.includes(item.variantId);
		});
	}

	function buildCinchPayload(config, paidItems, giftItems, requestedBundleId) {
		const paidUnits = expandCinchPaidItems(paidItems);
		if (!paidUnits.length || paidItems.some(function (item) { return item.id === null || item.quantity < 1; })) {
			return { error: 'Choose all bundle products before adding to cart.' };
		}
		if (!paidUnits.every(function (item) { return cinchItemIsEligible(config, item); })) {
			return { error: 'One or more selected products are not eligible for this bundle.' };
		}
		if (!validateCinchSections(config, paidUnits) || !validateCinchQuantityCap(config, paidUnits)) {
			return { error: 'The selected products do not meet this bundle’s section or quantity rules.' };
		}

		const tier = selectCinchTier(config.t, paidUnits.length);
		if (!tier) return { error: 'This selection does not qualify for a bundle tier.' };
		if (!validateCinchGifts(tier, giftItems)) {
			if (!giftItems.length && cinchMinimumGiftCount(tier) > 0) {
				return { error: 'This bundle tier requires a gift selector that is not available in this template.' };
			}
			return { error: 'The gifts from this bundle are no longer valid for the selected tier.' };
		}

		const bundleId = requestedBundleId || createCinchBundleId(config.i);
		return {
			items: buildCinchCartItems(config, tier, bundleId, paidItems, giftItems),
			bundleId: bundleId,
			tierId: tier.i
		};
	}

	function getCinchPreselectedGifts(config, paidCount) {
		const tier = selectCinchTier(config.t, paidCount);
		if (!tier || !Array.isArray(tier.pre) || !Array.isArray(tier.gv)) return [];
		const giftItems = [];
		tier.pre.forEach(function (variantId) {
			if (giftItems.length >= tier.g1 || !tier.gv.includes(variantId)) return;
			if (giftItems.some(function (item) { return item.variantId === variantId; })) return;
			giftItems.push({
				id: positiveInteger(variantId),
				variantId: variantId,
				productId: '',
				quantity: 1
			});
		});
		return giftItems;
	}

	function buildCinchTrioItems(section, config, requestedBundleId, giftItems) {
		const paidItems = getSelectedTrioItems(section).map(function (item) {
			return Object.assign({}, item, { quantity: 1 });
		});
		const gifts = Array.isArray(giftItems)
			? giftItems
			: getCinchPreselectedGifts(config, paidItems.length);
		return buildCinchPayload(config, paidItems, gifts, requestedBundleId);
	}

	function updateTrioProductSlider() {
		var swiperEl = document.querySelector('.swiper-trio');
		var slider = swiperEl && swiperEl.swiper;
		if (slider) slider.update();
	}

	function clearTrioBundleEditMode() {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.delete('edit');
		currentUrl.searchParams.delete('bundle');
		window.history.replaceState(null, '', currentUrl);
		trioBundleEditKey = null;
		trioCinchBundleEditId = null;
		trioBundleEditItem = null;
		trioCinchEditOriginal = null;
		trioCinchEditReady = false;
		document.querySelectorAll('[data-trio-cinch-editing]').forEach(function (section) {
			delete section.dataset.trioCinchEditing;
		});
	}

	function selectTrioBundleComponents(trioComponents, section) {
		const selectedCards = [];
		const selectedRadios = [];
		if (!section || !trioComponents.length) return false;

		trioComponents.forEach(function (itemComponent) {
			if (Number(itemComponent.quantity || 1) !== 1) return;
			const radio = section.querySelector('.trio-bundle-container input[data-variant-id="' + itemComponent.id + '"]');
			const card = radio && radio.closest('.product__card-alt');
			if (!radio || !card) return;
			selectedRadios.push(radio);
			if (selectedCards.indexOf(card) === -1) selectedCards.push(card);
		});

		if (!selectedCards.length
			|| selectedRadios.length !== trioComponents.length
			|| selectedCards.length !== trioComponents.length) return false;

		section.querySelectorAll('.trio-bundle-container .product__card-alt').forEach(function (card) {
			card.classList.add('hidden');
		});
		section.querySelectorAll('.swiper-trio .swiper-slide').forEach(function (slide) {
			slide.classList.add('hidden');
		});

		selectedCards.forEach(function (card) {
			const handle = card.dataset.productHandle;
			const productSwitch = card.querySelector('.trio-product-switch');
			card.classList.remove('hidden');
			if (handle && productSwitch) productSwitch.value = handle;
			if (handle) {
				const slide = section.querySelector('.swiper-trio .swiper-slide[data-handle="' + handle + '"]');
				if (slide) slide.classList.remove('hidden');
			}
		});

		selectedRadios.forEach(function (radio) {
			radio.checked = true;
			radio.dispatchEvent(new Event('change', { bubbles: true }));
		});

		updateTrioProductSlider();
		return true;
	}

	function getCartRoot() {
		return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
			? window.Shopify.routes.root
			: '/';
	}

	async function requestCartJson(path, body) {
		const options = { headers: { Accept: 'application/json' } };
		if (body !== undefined) {
			options.method = 'POST';
			options.headers['Content-Type'] = 'application/json';
			options.body = JSON.stringify(body);
		}

		try {
			const response = await fetch(getCartRoot() + path, options);
			let data = null;
			try {
				data = await response.json();
			} catch (error) {
				data = null;
			}
			const message = data && (data.description || data.message);
			return { ok: response.ok && !(data && data.status), data: data, message: message || null };
		} catch (error) {
			return { ok: false, data: null, message: null };
		}
	}

	function itemHasCinchBundleId(item, bundleId) {
		return getTrioCartProperty(item && item.properties, CINCH_LINE_PROPERTIES.bundleId) === bundleId;
	}

	function findCinchBundleItem(cartItems, bundleId) {
		if (!Array.isArray(cartItems)) return null;
		return cartItems.find(function (item) {
			return Array.isArray(item.item_components) && item.item_components.some(function (component) {
				return itemHasCinchBundleId(component, bundleId);
			});
		}) || cartItems.find(function (item) {
			return itemHasCinchBundleId(item, bundleId);
		}) || null;
	}

	async function removeCinchBundleLines(bundleId, sections) {
		const cartResult = await requestCartJson('cart.js');
		if (!cartResult.ok || !cartResult.data || !Array.isArray(cartResult.data.items)) return cartResult;
		const updates = {};
		cartResult.data.items.forEach(function (item) {
			if (itemHasCinchBundleId(item, bundleId) && typeof item.key === 'string' && item.key) {
				updates[item.key] = 0;
			}
		});
		if (!Object.keys(updates).length) return { ok: true, data: cartResult.data, message: null };
		const body = {
			updates: updates,
			sections_url: window.location.pathname
		};
		if (sections && sections.length) body.sections = sections.join(',');
		return requestCartJson('cart/update.js', body);
	}

	async function cinchBundleExists(bundleId) {
		const cartResult = await requestCartJson('cart.js');
		return Boolean(
			cartResult.ok
			&& cartResult.data
			&& Array.isArray(cartResult.data.items)
			&& cartResult.data.items.some(function (item) { return itemHasCinchBundleId(item, bundleId); })
		);
	}

	async function checkCinchBundleCapacity(replacingBundleId) {
		const cartResult = await requestCartJson('cart.js');
		if (!cartResult.ok || !cartResult.data || !Array.isArray(cartResult.data.items)) return { ok: true };
		const bundleIds = new Set();
		cartResult.data.items.forEach(function (item) {
			const bundleId = getTrioCartProperty(item.properties, CINCH_LINE_PROPERTIES.bundleId);
			if (bundleId) bundleIds.add(bundleId);
		});
		return bundleIds.size < CINCH_MAX_MERGE_BUNDLES || (replacingBundleId && bundleIds.has(replacingBundleId))
			? { ok: true }
			: { ok: false, message: CINCH_BUNDLE_LIMIT_MESSAGE };
	}

	function cartSections(cartHolder) {
		if (!cartHolder || typeof cartHolder.getSectionsToRender !== 'function') return [];
		return cartHolder.getSectionsToRender()
			.map(function (cartSection) { return cartSection.id; })
			.filter(function (id, index, ids) { return id && ids.indexOf(id) === index; })
			.slice(0, 5);
	}

	async function addCartItems(items, sections, expectedCinchBundleId, includeSections) {
		const body = { items: items };
		if (includeSections !== false && sections.length) {
			body.sections = sections.join(',');
			body.sections_url = window.location.pathname;
		}
		const result = await requestCartJson('cart/add.js', body);
		if (!result.ok && expectedCinchBundleId && await cinchBundleExists(expectedCinchBundleId)) {
			return { ok: true, data: null, message: null };
		}
		return result;
	}

	async function replaceCinchBundle(oldBundleId, newBundleId, items, sections) {
		const addResult = await addCartItems(items, sections, newBundleId, false);
		if (!addResult.ok) return addResult;

		const removeOldResult = await removeCinchBundleLines(oldBundleId, sections);
		if (removeOldResult.ok) return removeOldResult;

		const cleanupResult = await removeCinchBundleLines(newBundleId, sections);
		return {
			ok: false,
			data: cleanupResult.ok ? cleanupResult.data : null,
			message: cleanupResult.ok
				? "We couldn't update your bundle. Your original bundle is still in the cart."
				: "We couldn't finish updating your bundle. Review your cart before checkout."
		};
	}

	async function updateCartLines(updates, sections) {
		const body = {
			updates: updates,
			sections_url: window.location.pathname
		};
		if (sections.length) body.sections = sections.join(',');
		return requestCartJson('cart/update.js', body);
	}

	function renderTrioCart(cartHolder, response) {
		if (cartHolder && cartHolder.classList.contains('is-empty')) {
			cartHolder.classList.remove('is-empty');
		}
		if (response && cartHolder && typeof cartHolder.renderContents === 'function') {
			cartHolder.renderContents(response);
		} else {
			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
				bubbles: true,
				detail: { source: 'cinch' }
			}));
		}
	}

	// The theme's cart drawer links Cinch bundles with ?bundle=<bundle id> and
	// legacy trio bundles with ?edit=<line key>. Keep both formats working.
	async function initTrioBundleEditMode() {
		const button = document.querySelector('.product-form__trio');
		if ((!trioBundleEditKey && !trioCinchBundleEditId) || !button) return;
		const section = getTrioSection(button);
		const buttonLabel = button.querySelector('span');
		trioBundleDefaultButtonText = buttonLabel ? buttonLabel.textContent : 'Add Bundle';
		button.dataset.trioEditLoading = 'true';
		button.classList.add('disabled');
		button.disabled = true;
		if (buttonLabel) buttonLabel.textContent = 'Loading Bundle...';

		const cartResult = await requestCartJson('?view=cart_js');
		const cartItems = cartResult.data && Array.isArray(cartResult.data.items) ? cartResult.data.items : [];
		let editInitialized = false;

		if (cartResult.ok && trioCinchBundleEditId) {
			const config = getCinchConfig(section);
			const bundleItem = findCinchBundleItem(cartItems, trioCinchBundleEditId);
			const components = getCinchEditComponents(bundleItem, cartItems, trioCinchBundleEditId);
			const correctCampaign = config && (
				getTrioCartProperty(bundleItem && bundleItem.properties, CINCH_LINE_PROPERTIES.campaignId) === config.i
				|| components.some(function (component) { return component.campaignId === config.i; })
			);
			const original = correctCampaign ? captureCinchOriginal(components, config) : null;

			if (original && selectTrioBundleComponents(original.paid, section)) {
				trioBundleEditItem = bundleItem;
				trioCinchEditOriginal = original;
				trioCinchEditReady = true;
				section.dataset.trioCinchEditing = 'true';
				editInitialized = true;
			}
		} else if (cartResult.ok && trioBundleEditKey) {
			trioBundleEditItem = cartItems.find(function (item) {
				return item.key === trioBundleEditKey;
			});
			const components = getTrioEditComponents(trioBundleEditItem);
			if (trioBundleEditItem && selectTrioBundleComponents(components, section)) editInitialized = true;
		}

		if (editInitialized) {
			if (buttonLabel) buttonLabel.textContent = 'Update Bundle';
			delete button.dataset.trioEditLoading;
			button.classList.remove('disabled');
			button.disabled = false;
			return;
		}

		clearTrioBundleEditMode();
		if (buttonLabel) buttonLabel.textContent = trioBundleDefaultButtonText;
		delete button.dataset.trioEditLoading;
		updateTrioButtonAvailability(section);
	}

	async function initializeTrioBundlePage() {
		await initializeCinchPreviews(document);
		await initTrioBundleEditMode();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initializeTrioBundlePage);
	} else {
		initializeTrioBundlePage();
	}

	$(document).on('click', '.product-form__trio', async function(e){
		e.preventDefault();
		const $this = $(this);
		const section = getTrioSection(this);
		const cinchCampaignId = getCinchCampaignId(section);
		const cinchConfig = getCinchConfig(section);
		if ($this.hasClass('disabled') || this.disabled) return;
		if (cinchCampaignId && !cinchConfig) return;

		const _timestamp = new Date().getTime();
		let cartItems = [];
		let cinchBundleId = null;
		let cinchTierId = null;
		const isCinchEditMode = Boolean(cinchConfig && trioCinchBundleEditId && trioCinchEditReady);
		const isLegacyEditMode = Boolean(trioBundleEditKey && trioBundleEditItem && Object.keys(trioBundleEditItem).length);
		const isEditMode = isCinchEditMode || isLegacyEditMode;
		const originalText = $this.find('span').text();
		const defaultButtonText = isEditMode && trioBundleDefaultButtonText
			? trioBundleDefaultButtonText
			: originalText;
		const editButtonText = isEditMode ? 'Update Bundle' : defaultButtonText;

		function restoreTrioButton(statusText, nextText) {
			$this.find('span').text(statusText);
			setTimeout(function(){
				$this.find('span').text(nextText);
				const campaignConfigured = Boolean(getCinchCampaignId(section));
				const canEnable = !campaignConfigured || Boolean(getCinchConfig(section));
				$this.toggleClass('disabled', !canEnable).prop('disabled', !canEnable);
			}, 500);
		}

		function notifyCinchAdded(replaced) {
			if (!cinchConfig) return;
			document.dispatchEvent(new CustomEvent('cinch:added', {
					detail: {
						bundleId: cinchBundleId,
						campaignId: cinchConfig.i,
						tierId: cinchTierId,
						items: cartItems,
						replaced: replaced
					}
				}));
		}

		if (cinchConfig) {
			const cinchPayload = buildCinchTrioItems(
				section,
				cinchConfig,
				null,
				isCinchEditMode && trioCinchEditOriginal ? trioCinchEditOriginal.gifts : undefined
			);
			if (cinchPayload.error) {
				alert(cinchPayload.error);
				return;
			}
			cartItems = cinchPayload.items;
			cinchBundleId = cinchPayload.bundleId;
			cinchTierId = cinchPayload.tierId;
		} else {
			$(section).find('.trio-bundle-container .product__card-alt:not(.hidden)').each(function () {
				const $variant = $(this).data('variant-id');
				cartItems.push({
					quantity: 1,
					id: $variant,
					properties: {
						_bundle_type: 'trio',
						_bundle_product: 'Yes',
						_unique_bundle_id: _timestamp,
						_bundle_item: 'Yes'
					}
				});
			});

			const parentVariantInput = section && section.querySelector('input[name="id"]');
			const parentVariant = positiveInteger(parentVariantInput && parentVariantInput.value);
			if (parentVariant === null) {
				alert('This bundle is currently unavailable.');
				return;
			}
			cartItems.push({
				quantity: 1,
				id: parentVariant,
				properties: {
					_bundle_type: 'trio',
					_bundle_product: 'Yes',
					_unique_bundle_id: _timestamp,
					_bundle_item: 'Yes'
				}
			});
		}

		$this.find('span').text(isEditMode ? 'Updating...' : 'Adding...');
		$this.addClass('disabled').prop('disabled', true);
		if (cinchConfig) {
			const capacity = await checkCinchBundleCapacity(isCinchEditMode ? trioCinchBundleEditId : null);
			if (!capacity.ok) {
				section.dispatchEvent(new CustomEvent('bundle:error', {
					bubbles: true,
					detail: { message: capacity.message, code: 'bundle_limit' }
				}));
				restoreTrioButton(isEditMode ? 'Update failed' : 'Add failed', editButtonText);
				alert(capacity.message);
				return;
			}
		}
		const cartHolder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		const sections = cartSections(cartHolder);
		if (cartHolder && typeof cartHolder.setActiveElement === 'function') {
			cartHolder.setActiveElement(document.getElementById('CartDrawer'));
		}

		const addResult = isCinchEditMode
			? await replaceCinchBundle(
				trioCinchBundleEditId,
				cinchBundleId,
				cartItems,
				sections
			)
			: await addCartItems(cartItems, sections, cinchBundleId);
		if (!addResult.ok) {
			if (isCinchEditMode || addResult.data) renderTrioCart(cartHolder, addResult.data);
			restoreTrioButton(isEditMode ? 'Update failed' : 'Add failed', editButtonText);
			alert(addResult.message || (isEditMode
				? 'The bundle could not be updated. Please review your selections and try again.'
				: 'The bundle could not be added. Please review your selections and try again.'));
			return;
		}

		let cartResponse = addResult.data;
		if (isLegacyEditMode) {
			const updates = {};
			updates[trioBundleEditKey] = 0;
			const updateResult = await updateCartLines(updates, sections);
			if (!updateResult.ok) {
				renderTrioCart(cartHolder, cartResponse);
				restoreTrioButton('Update failed', editButtonText);
				alert(updateResult.message || 'The original bundle could not be removed from the cart.');
				return;
			}
			cartResponse = updateResult.data;
		}

		if (isCinchEditMode) {
			trioCinchBundleEditId = cinchBundleId;
			const currentUrl = new URL(window.location.href);
			currentUrl.searchParams.set('bundle', cinchBundleId);
			window.history.replaceState(window.history.state, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
		}

		renderTrioCart(cartHolder, cartResponse);
		notifyCinchAdded(isEditMode);
		if (isLegacyEditMode) clearTrioBundleEditMode();
		restoreTrioButton(isEditMode ? 'Updated!' : 'Added!', isCinchEditMode ? 'Update Bundle' : defaultButtonText);
	});

	$(document).on('click', '.view-trio-details', function (e) {
		e.preventDefault();
		var id = $(this).data('id');
		var swiperEl = document.querySelector('.swiper-trio');
		var slider = swiperEl && swiperEl.swiper;
		if (!slider) return;
		var visibleSlides = Array.from(slider.slides).filter(function (slide) {
			return !slide.classList.contains('hidden');
		});
		var slideIndex = -1;
		visibleSlides.forEach(function (slide, i) {
			if (slide.dataset.id === id) slideIndex = i;
		});
		if (slideIndex === -1) return;
		slider.slideTo(slideIndex, 300);
		var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
		var topOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--top-offset'), 10) || 0;
		$('html, body').animate({
			scrollTop: $('.trio-product-details-slider').offset().top - headerHeight - topOffset
		}, 400);
	});

	$(document).on('click', '.trio-product-right h4', function(){
		$(this).toggleClass('open-next-tab');
	});

	function updateTrioButtonAvailability(scope) {
		$(scope || document).find('.product-form__trio').each(function () {
			const section = getTrioSection(this);
			const campaignConfigured = Boolean(getCinchCampaignId(section));
			const editLoading = this.dataset.trioEditLoading === 'true';
			const canEnable = !editLoading && (!campaignConfigured || Boolean(getCinchConfig(section)));
			$(this).toggleClass('disabled', !canEnable).prop('disabled', !canEnable);
		});
	}

	$(window).on('load', function(){
		updateTrioButtonAvailability(document);
	});
	$(document).on('shopify:section:load', function (event) {
		initializeCinchPreviews(event.target);
		updateTrioButtonAvailability(event.target);
	});
})();
